import * as Constants from '../constants/table';

const encodeQueryData = (data) => {
  const res = Object.keys(data).reduce((acc, key) => {
    acc.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
    return acc;
  }, []);

  return res.join('&');
};

export const setTableDataInfo = (payload) => (dispatch) =>
  dispatch({ type: Constants.SET_TABLE_DATA_INFO, payload });

export const getTableData = ($http, ENV, endpoint, data_key, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    const url = `${ENV.apiEndpoint}${endpoint}?${encodeQueryData(params)}`;
    dispatch({ type: Constants.GET_TABLE_DATA_REQUEST });
    dispatch({ type: Constants.SET_TABLE_DETAIL_URL, payload: url });
    if (data_key === 'users') {
      dispatch({ type: Constants.SET_TABLE_DATA_INFO, payload: { url, key: data_key } });
    }

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + endpoint,
      params,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_TABLE_DATA_SUCCESS, payload: res.data[data_key] });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_TABLE_DATA_FAILED, payload: error });
        reject(error);
      });
  });

export const getTableDataByUrl = ($http, url, data_key) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_TABLE_DATA_BY_URL_REQUEST });
    dispatch({ type: Constants.SET_TABLE_DETAIL_URL, payload: url });
    if (data_key === 'users') {
      dispatch({ type: Constants.SET_TABLE_DATA_INFO, payload: { url, key: data_key } });
    }

    $http({
      method: 'GET',
      url,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_TABLE_DATA_BY_URL_SUCCESS, payload: res.data[data_key] });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_TABLE_DATA_BY_URL_FAILED, payload: error });
        reject(error);
      });
  });

export const getTableFilterOptions = ($http, ENV, endpoint, data_key) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_TABLE_DATA_FILTER_CHOICES_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + endpoint,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_TABLE_DATA_FILTER_CHOICES_SUCCESS,
          payload: res.data[data_key],
        });
        resolve(res.data[data_key]);
      })
      .catch((error) => {
        dispatch({
          type: Constants.GET_TABLE_DATA_FILTER_CHOICES_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const angucompleteSearch = ($http, ENV, endpoint, data_key, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + endpoint,
      params,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_SUCCESS,
          payload: res[data_key],
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_FAILED, payload: error });
        reject(error);
      });
  });

export const angucompleteSearchByUrl = ($http, url, data_key) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_REQUEST });

    $http({
      method: 'GET',
      url,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_SUCCESS,
          payload: res[data_key],
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({
          type: Constants.GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_FAILED,
          payload: error,
        });
        reject(error);
      });
  });
